import React, { FunctionComponent } from 'react';
import { ColorModeContext } from '../context/ColorModeContext';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

import { useUserSettings } from '@/modules/users/contexts/UserSettingsContext';
import { UserSettingKey } from '@/modules/users/api/user-settings/user-setting.contracts';
import { MainMenuButton } from './MainMenuButton';
import { useTranslation } from '@/lib';

export const ColorModeToggleButton: FunctionComponent = () => {
  const colorMode = React.useContext(ColorModeContext);
  const { setUserSettingByKey } = useUserSettings();
  const { t } = useTranslation();

  function onToggleDarkModeClicked() {
    setUserSettingByKey(UserSettingKey.DARK_MODE_ENABLED, colorMode.mode === 'dark' ? false : true, false);
    colorMode.toggleColorMode();
  }

  return (
    <MainMenuButton
      isActive={false}
      label={t('toggle_dark_mode')}
      icon={colorMode.mode === 'dark' ? <Brightness4Icon fontSize="inherit" /> : <Brightness7Icon fontSize="inherit" />}
      onClick={onToggleDarkModeClicked}
    />
  );
};
